import { render, staticRenderFns } from "./veStuCheckNormEdit.vue?vue&type=template&id=2645d1ea&scoped=true"
import script from "./veStuCheckNormEdit.vue?vue&type=script&lang=js"
export * from "./veStuCheckNormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645d1ea",
  null
  
)

export default component.exports